// "Continue with Google" (Google Identity Services). The browser gets a signed ID token from Google and hands it to our server, which
// checks it (services/googleSignIn.js) and logs the customer in. Nothing here needs a secret: the client id is public.
// Without REACT_APP_GOOGLE_CLIENT_ID the button is simply not offered and the mobile number login is used.
const SCRIPT_URL = 'https://accounts.google.com/gsi/client';
const clientId = () => String(process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();

export const googleSignInAvailable = () => Boolean(clientId());

let scriptPromise = null;
const loadScript = () => {
  if (window.google && window.google.accounts && window.google.accounts.id) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const tag = document.createElement('script');
      tag.src = SCRIPT_URL;
      tag.async = true;
      tag.defer = true;
      tag.onload = () => resolve();
      tag.onerror = () => { scriptPromise = null; reject(new Error('Google sign-in could not be loaded')); };
      document.head.appendChild(tag);
    });
  }
  return scriptPromise;
};

// Starts fetching Google's script in the background (the booking page calls this when it opens), so the button is ready the moment the
// pop-up appears instead of waiting for the download then.
export const preloadGoogleSignIn = () => {
  if (googleSignInAvailable()) loadScript().catch(() => {});
};

// Draws Google's own button inside `element`; `onCredential(idToken)` runs when the customer picks an account.
export const renderGoogleButton = async (element, onCredential) => {
  await loadScript();
  const { id } = window.google.accounts;
  id.initialize({ client_id: clientId(), callback: (response) => { if (response && response.credential) onCredential(response.credential); }, ux_mode: 'popup' });
  const width = Math.max(200, Math.min(400, Math.round(element.parentElement?.clientWidth || 320)));
  id.renderButton(element, { type: 'standard', theme: 'outline', size: 'large', text: 'continue_with', shape: 'rectangular', logo_alignment: 'left', width });
};
